<div>
  <div class="flex-column text-center mb-2">
    <div *ngIf="supplier">
      <div>
        <img src="{{ 'assets/suppliers/' + supplier?.logoName}}" style="width: 100px;" alt="Supplier Logo"
          onerror="this.src='assets/suppliers/default.png'">
      </div>
      <div class="mt-2"><strong>{{ supplier?.name || '' }}</strong></div>
    </div>
  </div>
  <div *ngIf="winningsUser" class="mb-2">
    <pcc-select-supplier></pcc-select-supplier>
  </div>
  <p-panelMenu [multiple]="false" [model]="menuItems">
  </p-panelMenu>
</div>
